<template>
  <v-card>
    <v-spacer></v-spacer>
    <v-toolbar
        elevation="1"
        color="#BC0000"
        dark
    >
      <v-card-text class="d-flex justify-center pt-4 ">
        <h2 class="text--white text-center">Nova categoria</h2>
      </v-card-text>

      <v-btn absolute top right color="#ccc" icon @click="close">
        <v-icon size="22">mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text class="px-2 py-0 mt-2">
      <v-form ref="form" v-model="valid" @submit.prevent="submit">
        <v-col cols="12" sm="12" md="12" lg="12">
          <div class="d-flex flex-column align-center justify-center">
            <v-hover v-slot="{ hover }" v-if="currentCategory.pathImage != null">
              <v-img
                  :src="currentCategory.pathImage"
                  style="
                    border-radius: 5px !important;
                    opacity: 0.8;
                    cursor: pointer;
                  "
                  max-height="166"
                  max-width="221"
                  :class="hover ? 'elevation-5 mx-2' : 'mx-2'"
              >
                <v-expand-transition>
                  <div
                      v-if="hover"
                      class="d-flex flex-column justify-center align-center"
                      style="height: 100%; background: rgba(188, 0, 0, 0.6)"
                      @click="openPicker"
                  >
                    <v-icon size="26" color="white">mdi-pen</v-icon>
                    <span class="edit-photo">Alterar foto</span>
                  </div>
                </v-expand-transition>
              </v-img>
            </v-hover>

            <span
                class="delete-photo"
                v-if="currentCategory.pathImage != null"
                @click="currentCategory.pathImage = null"
            >
                Excluir
              </span>

            <div
                class="d-flex flex-column align-center"
                style="max-width: 150px"
                v-if="currentCategory.pathImage == null"
            >
              <v-hover v-slot="{ hover }">
                <div class="image-container mx-2" @click="openPicker">
                  <v-img
                      src="../../../../../assets/imp.svg"
                      contain
                      v-if="!hover"
                      max-width="157"
                  ></v-img>

                  <div class="d-flex flex-column align-center">
                    <v-img
                        src="../../../../../assets/add_photo.svg"
                        contain
                        max-width="46"
                    ></v-img>
                    <span class="photo-field" v-if="hover">
                        Adicionar Foto
                      </span>
                  </div>
                </div>
              </v-hover>
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12">
          <span class="label-details" >Nome</span>
          <v-text-field
            outlined
            v-model="currentCategory.categoryName"
            placeholder="Nome da categoria"
            :rules="[(v) => !!v || 'Campo obrigatório!']"
            required
            class="mt-2"
            style="border: 1px solid #979797; border-radius: 5px"
            color="black"
            full-width
            background-color="#F5F5F5"
            hide-details
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12">
          <span class="label-details">Descrição</span>
          <quill-editor
              :content="currentCategory.categoryDescriptionHtml"
              @change="onEditorChange($event)"
              ref="myQuill"
          >
          </quill-editor>
        </v-col>

        <v-row class="ma-0 mt-3 mb-2" align="end" justify="between" cols="12">
          <v-col cols="12" sm="10" md="10" lg="10">
            <label class="label-details">Palavra-chave</label>
            <v-text-field
                outlined
                v-model="keyWord"
                placeholder="Digite a palavra-chave"
                class="mt-2"
                style="border: 1px solid #979797; border-radius: 5px"
                color="black"
                full-width
                background-color="#F5F5F5"
                hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="2" md="2" lg="2">
            <v-btn
                fab
                tile
                height="60"
                width="100%"
                style="border-radius: 6px; margin-bottom: -2px"
                small
                elevation="0"
                @click="addkeyWord()"
                color="red"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="ma-0 mt-3 mx-0 mb-2" align="end" justify="between" cols="12" v-if="keyWords && keyWords.length > 0">
          <v-col cols="12" sm="12" md="12" lg="12" >
            <p class="label-details">Palavras-chave</p>
            <section class="keyWords">
              <p
                  class="d-inline-flex align-center mr-2 keyWord"
                  v-for="(keyWord, index) in keyWords" :key="`${index}-${keyWord}`"
              >
                <span>
                  {{keyWord}}
                </span>

                <v-icon
                    size="20"
                    color="#FFFFFF"
                    style="cursor: pointer"
                    @click="removeKeyWord(keyWord)"
                >
                  mdi-close
                </v-icon>
              </p>
            </section>
          </v-col>
        </v-row>

        <v-col cols="12" sm="12" md="12" lg="12" class="d-flex ma-0 pa-0">
          <v-checkbox
            style="border-radius: 4px !important"
            outlined
            class="mr-5 ml-2"
            color="black"
            v-model="currentCategory.statusOnMenu"
            label="Incluir esta categoria no menu principal"
            :value="currentCategory.statusOnMenu"
            hide-details
            required
          ></v-checkbox>

          <v-checkbox
              style="border-radius: 4px !important"
              outlined
              color="black"
              v-model="currentCategory.showHomepage"
              label="Incluir esta categoria na página inicial"
              :value="currentCategory.showHomepage"
              hide-details
              required
          ></v-checkbox>
        </v-col>
      </v-form>

      <v-row class="pa-2 ma-0 mt-3 mb-2" align="end" justify="center" >
        <v-col cols="12" sm="8" md="8" lg="8" class="ma-0 pa-0 pr-1">
          <span class="ml-1">Subcategoria</span>
          <v-select
            style="border-radius: 7.5px; font-weight: normal !important"
            append-icon="mdi-chevron-down"
            placeholder="selecione"
            hide-details
            clearable
            color="white"
            background-color="normalred"
            dark
            outlined
            :items="subcategories"
            item-text="name"
            item-value="subCategoryId"
            v-model="currentSubCategoryId"
            required
          ></v-select>
        </v-col>

        <v-col cols="12" sm="4" md="4" lg="4" class="ma-0 pa-0 pl-1">
          <v-btn
              class="add-button"
              width="100%"
              outlined
              elevation="0"
              @click="addSubcategory"
              large
          >
            Adicionar subcategoria
          </v-btn>
        </v-col>
        <v-divider />
      </v-row>

      <div
        v-for="(subcategory, i) in currentCategory.subCategoriesToCategory"
        :key="i"
      >
        <div class="dividers pl-2 pt-2 pb-2 mb-3">
          <span class="pl-2"> {{ subcategory.subCategory.name }}</span>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  tile
                  style="border-radius: 6px"
                  small
                  @click="removeLine(subcategory)"
                  v-bind="attrs"
                  color="red"
                  v-on="on"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </div>
        </div>

        <v-divider />
      </div>
    </v-card-text>

    <v-card-actions class="mt-0">
      <v-row class="ma-0">
        <v-col cols="12" sm="6" md="6" lg="6" >
          <v-btn
            class="cancel-button"
            height="50"
            width="100%"
            @click="close"
            elevation="0"
            outlined
          >
            Cancelar
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-btn
            class="cadaster-button"
            height="50"
            width="100%"
            elevation="0"
            dark
            @click="openDialog"
          >
            <span>Cadastrar</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>

    <v-file-input
        id="imageInput"
        accept="image/png, image/jpeg,image/jpg"
        style="display: none"
        @change="setImage"
    ></v-file-input>

    <v-dialog v-model="confirmDialog" max-width="500">
      <ConfirmModal
        textMessage="Aviso de alterações"
        cancelBtn="Cancelar"
        title="Atenção"
        okbtn="Sim"
        textObservation1="Se você editar essa categoria, ela será editada em todos os produtos em uso!"
        @close="confirmDialog = false"
        @action="submit"
      />
    </v-dialog>
  </v-card>
</template>

<style scoped>
.dividers {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f5f5;
  border-radius: 4px;
  font-weight: bold;
}
.main-title {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  color: #000000;
}

.label {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.2px;
  color: #232021;
}

.cadaster-button {
  border-radius: 7.5px !important;
  transition: 0.3s;
  background: black !important;
  font-weight: bold;
  font-size: 18px;
  color: #ffffff;
}

.cadaster-button:hover {
  color: white !important;
  background: #313236 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.cancel-button {
  border-radius: 7.5px !important;
  border: 2px solid #2d3038;
  box-sizing: border-box;
  font-weight: bold;
  transition: 300ms;
}

.cancel-button:hover {
  background: #2d3038;
  color: white !important;
}

.cancel-button:focus {
  background: #444854;
  color: white !important;
}
.edit-photo {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #ffffff;
}
.photo-field {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 221px;
  height: 166px;
  background: #dadada;
  cursor: pointer;
  transition: 0.1s;
  box-sizing: border-box;
  border-radius: 10px !important;
}
.keyWords{
  border: 2px solid #BC0000;
  border-radius: 6px;
  padding: 10px;
}
.keyWord{
  background: #BC0000;
  padding: 2px 10px;
  border-radius: 12px;
  color: #FFFFFF;
  font-weight: 500;
}
</style>

<script scoped>
import ConfirmModal from "../../../components/ConfirmModal.vue";
import ApiService from "../../../../../services/ApiService";
import Vue from "vue";

export default {
  name: "ImportExcel",

  props: {
    textMessage: String,
    icone: String,
    title: String,
    route: String,
    typeRoute: String,
    category: Object,
  },

  async created() {
    await this.updateSubcategories();
    if (this.category.categoryName != null) {
      this.currentCategory = this.category;
      this.keyWords = this.currentCategory.keyWords ? this.currentCategory.keyWords.split(',') : [];
      this.isEditing = true;
    } else {
      this.isEditing = false;
    }
  },

  data: () => ({
    subcategories: [],
    addedSubcategories: {},
    currentSubCategoryId: 0,
    confirmDialog: false,
    valid: false,
    loading: false,
    isEditing: false,
    keyWord: null,
    keyWords: [],
    apiService: new ApiService(),
    currentCategory: {
      subCategoriesToCategory: [],
      pathImage: null,
      categoryDescription: '',
      keyWords: [],
    },
    newCategoryDialog: false,
    filter: {
      page: 1,
      pageSize: 15,
    },
  }),

  components: {
    ConfirmModal,
  },

  methods: {
    onEditorChange({quill, html, text}) {
      this.currentCategory.categoryDescriptionHtml = html
      this.currentCategory.categoryDescription = text
    },
    setImage(image) {
      if (image.size < 2097152) {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => {
          this.currentCategory.pathImage = reader.result;
        };
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "warning",
          title: "Erro",
          message: "Arquivo excede o limite de 2mb",
          trace: null,
        });
      }
    },

    openPicker() {
      document.querySelector("#imageInput").click();
    },

    addkeyWord(){
      if(this.keyWord) {
        this.keyWords.push(this.keyWord)
        this.keyWord = null
      }
    },

    removeKeyWord(keyWord){
      const index = this.keyWords.findIndex((x) => x === keyWord);
      this.keyWords.splice(index, 1);
    },

    showPhoto(image) {
      if (!!image && image.includes("Uploads/")) {
        const env_url = process.env.VUE_APP_BASE_URL;
        return env_url + image;
      } else {
        return image;
      }
    },

    addSubcategory() {
      this.loading = true;
      if (this.isEditing) {
        const findSubCategoryId =
          this.currentCategory.subCategoriesToCategory.find(
            (x) => x.subCategoryId === this.currentSubCategoryId
          );
        if (findSubCategoryId) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Nome da subcategoria já existe.",
            message: "Nome da subcategoria já existe.",
            trace: null,
          });
          return;
        }
      }
      const subcategory = this.subcategories.find(
        (x) => x.subCategoryId === this.currentSubCategoryId
      );
      this.currentCategory.subCategoriesToCategory.push({
        subCategory: {
          subCategoryId: subcategory.subCategoryId,
          name: subcategory.name,
        },
      });
    },

    async updateSubcategories() {
      this.loading = true;

      await this.apiService
        .get(`subcategory/listAll`)
        .then((response) => {
          this.subcategories = response;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    removeLine(i) {
      const indexCatagoria =
        this.currentCategory.subCategoriesToCategory.findIndex(
          (x) => x.subCategory.subCategoryId === i.subCategory.subCategoryId
        );
      this.currentCategory.subCategoriesToCategory.splice(indexCatagoria, 1);
    },

    action() {
      this.$emit("action");
    },

    close() {
      this.$emit("close");
      this.isEditing = false;
    },

    openDialog() {
      if (this.isEditing) {
        this.confirmDialog = true;
      } else {
        this.submit();
      }
    },

    async submit() {
      this.loading = true;

      if (this.$refs.form.validate()) {
        const category = this.currentCategory;
        category.statusOnMenu = category.statusOnMenu ? 1 : 0;
        category.showHomepage = category.showHomepage ? 1 : 0;
        category.keyWords = this.keyWords.join(', ');
        let url = "category/add";
        if (this.isEditing) {
          url = "category/edit";
        }
        await this.apiService
          .post(url, category)
          .then((resp) => {
            let token = localStorage.getItem("token");
            if (token) {
              this.close();
            } else {
              this.$router.push("/auth");
            }
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Categoria cadastrada com sucesso!",
              message: resp.message,
              trace: null,
            });

            this.loading = false;
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro ao cadastrar produto",
              message: err.body.message,
              trace: null,
            });
            this.close();

            this.loading = false;
          });
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Formulário não validado",
          message: "Confira o preenchimento",
          trace: null,
        });

        this.loading = false;
      }
    },
  },
};
</script>
